// components/Admin/TitleProbabilityManager/TitleTable.jsx

import {
  Table, TableHead, TableBody, TableRow, TableCell,
  TextField, IconButton, MenuItem, Box, Pagination,
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import { useState } from 'react';

const TitleTable = ({
  titles,
  onDelete,
  onUpdate,
  tierOptions = [],
}) => {
  /* ───────── state ───────── */
  const [editingIndex, setEditingIndex] = useState(null);
  const [editedTitle, setEditedTitle] = useState({ name: '', tier: '' });

  // pagination
  const [page, setPage] = useState(1);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(titles.length / itemsPerPage);
  const currentItems = titles.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage,
  );

  /* ───────── helpers ───────── */
  const globalIdx = (localIdx) => (page - 1) * itemsPerPage + localIdx;

  const startEdit = (idx, title) => {
    setEditingIndex(globalIdx(idx));
    setEditedTitle({ ...title });
  };
  const cancelEdit = () => {
    setEditingIndex(null);
    setEditedTitle({ name: '', tier: '' });
  };
  const saveEdit = () => {
    if (!editedTitle.name || !editedTitle.tier) {
      alert('이름과 등급을 모두 입력해주세요.');
      return;
    }
    onUpdate(editingIndex, editedTitle);
    cancelEdit();
  };

  /* ───────── UI ───────── */
  const tinyBtn = { p: 0.25, width: 32, height: 32 };

  return (
    <>
      <Table size="small" sx={{ mt: 4 }}>
        <TableHead>
          <TableRow>
            <TableCell>칭호 이름</TableCell>
            <TableCell>등급</TableCell>
            {/* 가운데 정렬로 변경 */}
            <TableCell align="center">작업</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {currentItems.map((title, idx) => {
            const gIdx = globalIdx(idx);
            const isEditing = editingIndex === gIdx;
            return (
              <TableRow key={title.id || gIdx}>
                {/* 이름 */}
                <TableCell>
                  {isEditing ? (
                    <TextField
                      value={editedTitle.name}
                      onChange={(e) =>
                        setEditedTitle({ ...editedTitle, name: e.target.value })
                      }
                      size="small"
                    />
                  ) : (
                    <strong>{title.name}</strong>
                  )}
                </TableCell>

                {/* 등급 */}
                <TableCell>
                  {isEditing ? (
                    <TextField
                      select
                      value={editedTitle.tier}
                      onChange={(e) =>
                        setEditedTitle({ ...editedTitle, tier: e.target.value })
                      }
                      size="small"
                      sx={{ minWidth: 120 }}
                    >
                      {tierOptions.map((t) => (
                        <MenuItem key={t} value={t}>
                          {t}
                        </MenuItem>
                      ))}
                    </TextField>
                  ) : (
                    title.tier
                  )}
                </TableCell>

                {/* 작업 버튼 */}
                <TableCell align="center" sx={{ p: 0.5 }}>
                  <Box
                    sx={{
                      display: 'flex',
                      gap: 0.5,
                      justifyContent: 'center',   /* 가운데 정렬 */
                    }}
                  >
                    {isEditing ? (
                      <>
                        <IconButton sx={tinyBtn} onClick={saveEdit}>
                          <DoneIcon fontSize="small" />
                        </IconButton>
                        <IconButton sx={tinyBtn} onClick={cancelEdit}>
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      </>
                    ) : (
                      <>
                        <IconButton
                          sx={tinyBtn}
                          onClick={() => startEdit(idx, title)}
                        >
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton
                          sx={tinyBtn}
                          onClick={() => onDelete(title.id)}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </>
                    )}
                  </Box>
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>

      {/* 페이지네이션 */}
      {totalPages > 1 && (
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(_, v) => setPage(v)}
            size="small"
            shape="rounded"
            color="primary"
          />
        </Box>
      )}
    </>
  );
};

export default TitleTable;